import { render, staticRenderFns } from "./diseaseDetail.vue?vue&type=template&id=4bf7ce46&"
import script from "./diseaseDetail.vue?vue&type=script&lang=js&"
export * from "./diseaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./diseaseDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports